// extracted by mini-css-extract-plugin
export var footer = "footer-2Ex";
export var footer_nav = "footer_nav-1wY";
export var footer_info = "footer_info-u1o";
export var footer_content_blocks = "footer_content_blocks-JL6";
export var button = "button-1J3";
export var footer_banner = "footer_banner-2yo";
export var footer_content = "footer_content-zfd";